<template>
  <context-page :title="$t('subsidy.reviewBeneficiaries')" :showLoader="pageLoader">
    <v-card>
        <v-card-actions>
          <v-btn color="#429a86" dark tile @click="openAddBeneficiaryDialog" :loading="loading">
            <v-icon left>mdi-plus</v-icon>
            {{$t('subsidy.addBeneficiaries')}}</v-btn>
        </v-card-actions>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <VueTabulator id="userBeneficiaryTable" ref="tabulator" v-model="data" :options="tabulatorOptions" />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-dialog v-model="addDialog" width="550" persistent>
        <v-card tile flat class="pa-2" color="blue-grey lighten-5">
            <v-card-text class="py-2 px-2">
              <v-row dense>
                    <v-col>
                     <p>{{$t('subsidy.holderIdentificationNumber')}}</p>
                    </v-col>
                    <v-col>
                      <p>{{$t('subsidy.beneficiary')}}</p>
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col>
                      <v-text-field v-model="holderIdentificationNumber"></v-text-field>
                    </v-col>
                    <v-col>
                      <v-text-field v-model="beneficiary"></v-text-field>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-btn color="teal" dark tile class="text-none body-2 mr-1" @click="add">
                    <v-icon left>mdi-check</v-icon>
                    {{$t('form.apply')}}</v-btn>
                <v-btn color="blue-grey lighten-3" tile class="text-none body-2 mr-1" @click="addDialog = false">
                    <v-icon left>mdi-alert</v-icon>
                    {{$t('form.cancel')}}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
  </context-page>
</template>

<script>
import Vue from 'vue'
import ContextPage from '@/components/context-page/ContextPage'
import tabulatorMixin from '@/mixins/tabulator'
import { EventBus } from '@/router/bus'

export default {
  name: 'user-beneficiary',
  components: {
    ContextPage
  },
  mixins: [tabulatorMixin],
  data: function () {
    return {
      data: [],
      pageLoader: false,
      loading: false,
      addDialog: false,
      holderIdentificationNumber: '',
      beneficiary: '',
      beneficiaries: [],
      tabulatorOptions: {
        ajaxURL: Vue.$config.api_root_internal + '/' + Vue.$apiConfig.pagedBeneficiariesGet,
        columns: [
          { title: 'id', field: 'id', visible: false },
          { title: this.$t('subsidy.holderIdentificationNumber'), align: 'center', field: 'holderIdentificationNumber', headerFilter: this.vTextFieldFilter, headerFilterLiveFilter: false },
          // { title: this.$t('subsidy.subsidiaryIdentificationNumber'), align: 'center', field: 'subsidiaryIdentificationNumber', headerFilter: this.vTextFieldFilter, headerFilterLiveFilter: false },
          { title: this.$t('subsidy.beneficiaries'), align: 'center', field: 'beneficiaries', headerFilter: this.vTextFieldFilter, headerFilterLiveFilter: false },
          {
            title: this.$t('issue.createdDate'),
            align: 'center',
            field: 'createdDate',
            headerFilter: this.vDateRange,
            headerFilterLiveFilter: false,
            headerFilterParams: { isRange: true },
            formatter: (cell) => { return this.formatDate(cell.getValue()) }
          }
        ]
      }
    }
  },
  methods: {
    openAddBeneficiaryDialog () {
      this.addDialog = true
    },
    add () {
      this.addDialog = false
      this.beneficiaries = []
      this.beneficiaries.push(this.beneficiary)
      EventBus.$emit('page-loader', true)
      this.$http.post(Vue.$apiConfig.addBeneficiariesPost.replace('{uniqueIdentificationNumber}', this.holderIdentificationNumber), this.beneficiaries).then(
        response => {
          this.logConsole(response)
          this.clearData()
          this.tabulatorInstance.setData()
          EventBus.$emit('page-loader', false)
        },
        error => {
          this.logConsole(error)
          this.formatErrorResponse(error)
          this.clearData()
          EventBus.$emit('page-loader', false)
        })
    },
    clearData () {
      this.holderIdentificationNumber = ''
      this.beneficiary = ''
      this.beneficiaries = []
    }
  }
}
</script>
